/** See `src/i18n/locales/en/companies.ts`. */
export const companies = {
  list: {
    title: 'Entreprises',
    newCompany: 'Nouvelle entreprise',
    empty: 'Aucune entreprise ne vous est visible.',
    name: 'Nom',
    created: 'Créée',
    rowsLabel: 'les entreprises',
    healthTitle: 'Santé de l’organisation',
    healthCompanies: 'Entreprises',
    healthEditions: 'Éditions',
    healthPilots: 'Pilotes',
    healthPilotsLabel: 'le résumé des pilotes',
    healthActivePilotCount: '{{count}} entreprises avec un pilote actif',
  },
  detail: {
    thisCompany: 'entreprise',
    rename: 'Renommer',
    companyAdmins: 'Administrateurs de l’entreprise',
    delete: 'Supprimer',
    departmentsTitle: 'Départements',
    newDepartment: 'Nouveau département',
    departmentsEmpty: 'Pas encore de départements.',
    departmentsLabel: 'les départements',
    name: 'Nom',
    statistics: 'Statistiques',
    collectiveConsent: 'Consentement collectif',
    inForce: 'en vigueur',
    settingsTitle: 'Paramètres',
    settingsLabel: 'les paramètres',
    change: 'Modifier',
    minGroupSizeLabel: 'Taille minimale de groupe pour les agrégats :',
    systemDefault: 'valeur par défaut du système',
    companyOverride: 'valeur propre à l’entreprise',
    domainsTitle: 'Domaines e-mail',
    domainsLabel: 'les domaines',
    manage: 'Gérer',
    domainsEmpty: 'Aucun domaine enregistré.',
    membersTitle: 'Membres',
    membersLabel: 'les membres',
    addPerson: 'Ajouter une personne',
    membersEmpty: 'Aucun membre.',
    email: 'E-mail',
    login: 'Connexion',
    source: 'Source',
    actions: 'Actions',
    yes: 'oui',
    no: 'non',
  },
  form: {
    newTitle: 'Nouvelle entreprise',
    name: 'Nom',
    cancel: 'Annuler',
    create: 'Créer l’entreprise',
    editTitle: 'Renommer l’entreprise',
    save: 'Enregistrer',
    deleteTitle: 'Supprimer l’entreprise',
    deleteLead:
      'Supprimer {{name}} met aussi fin à ses domaines et à ses lignes d’adhésion. Cette action est irréversible. Tapez le nom de l’entreprise pour confirmer.',
    companyNameLabel: 'Nom de l’entreprise',
    deletePermanently: 'Supprimer définitivement',
    settingsTitle: 'Seuil d’agrégation',
    settingsLead:
      'La taille minimale de groupe en dessous de laquelle les agrégats ne sont pas affichés. Laissez vide pour revenir à la valeur par défaut du système. L’API impose un plancher strict.',
    minGroupSize: 'Taille minimale de groupe',
    domainsTitle: 'Domaines e-mail',
    domainsLead:
      'Une adresse vérifiée sur l’un de ces domaines rattache son titulaire à cette entreprise lors de la connexion. Les adhésions existantes restent lorsqu’un domaine est retiré.',
    remove: 'Retirer',
    addDomain: 'Ajouter un domaine',
    add: 'Ajouter',
    backToCompany: 'Retour à l’entreprise',
  },
  health: {
    title: 'Santé de l’organisation',
    edition: 'Édition',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Membres',
    pilotsTitle: 'Pilotes',
    pilotsLabel: 'le statut des pilotes',
    noPilots: 'Aucun pilote pour l’instant.',
    activeCount: '{{count}} actif(s)',
    scaledCount: '{{count}} déployé(s)',
    totalCount: '{{count}} au total',
    viewAllPilots: 'Voir tous les pilotes',
  },
} as const;
